import { render, staticRenderFns } from "./TituloVisualizarMatricula.vue?vue&type=template&id=1f874211&"
import script from "./TituloVisualizarMatricula.vue?vue&type=script&lang=js&"
export * from "./TituloVisualizarMatricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports